<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'riwayat-paket'" :loading="!formReady">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar page-title="Riwayat Pembelian Paket" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content>
                <div class="">
                    <div class="d-flex f-12 f-c-midgrey f-regular" style="align-items: baseline; padding: 10px 20px;">
                        <div class="no-telp">
                            <IconBased width="14" height="14">
                                <template v-slot:icons>
                                    <WhatsappIconMini clr-fill="#6F7287" />
                                </template>
                            </IconBased>
                            <span class="m-l-4">+{{ getCC }}{{ getNomorTelp }}</span>
                        </div>
                        <label class="m-d-0">{{ getNamaPerangkat }}</label>
                    </div>
                    <div class="separator-line"></div>
                    <div class="" v-if="totalListPaket > 0">
                        <CardPaket :data-list="listPaket" />
                    </div>
                    <SOLoadMoreLoading :id="'load-more-mesin-edc'" :loading="isLoadMore" />
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

import IconBased from "../components/iconPack/IconBased.vue";
import WhatsappIconMini from "../components/iconPack/WhatsappIcon1414.vue";
import CardPaket from "../components/CardPaket.vue";

import { moduleName } from "../store/state";

export default {
    name: "RiwayatPaket",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOLoadMoreLoading,
        CardPaket,
        IconBased,
        WhatsappIconMini,
    },
    data() {
        return {
            formReady: false,
        };
    },
    mounted() {
        this.init();
    },
    beforeRouteLeave(to, from, next) {
        this.resetListPaket();
        this.setFormReady(false);
        next();
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);
            } else {
                this.setFormReady(true);
                if (newRes.err) {
                    this.$toast.error(newRes.err);
                }
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            dataDevice: "dataDevice",
            dataDeviceTiny: "dataDeviceTiny",
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            listPaket: "listPaket",
            totalListPaket: "totalListPaket",
            response: "response",
        }),
        getCC() {
            return this.dataDevice?.country_code || this.dataDeviceTiny.country_code;
        },
        getNomorTelp() {
            return this.dataDevice.nomor ? this.dataDevice.nomor : this.dataDeviceTiny.number;
        },
        getNamaPerangkat() {
            return this.dataDevice.nomor ? this.dataDevice.nama : this.dataDeviceTiny.nama;
        },
    },
    methods: {
        ...mapActions({
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            getRiwayatPaket: `${moduleName}/getRiwayatPaket`,
            resetPagePaket: `${moduleName}/resetPagePaket`,
            resetListPaket: `${moduleName}/resetListPaket`,
        }),
        async init() {
            if (!this.dataDevice.nomor) {
                await this.getDetailTinyDevice({ id_mesin: this.$route.params.id_device });
            }
            if (this.listPaket.length === 0) {
                await this.resetPagePaket();
                await this.getRiwayatPaket({ idMesin: this.$route.params.id_device });
            } else {
                await this.setFormReady(true);
            }
        },
        back() {
            this.$router.push({ name: "wa_autosender.detail_perangkat" });
        },
        setFormReady(val) {
            this.formReady = val;
        },
    },
};
</script>
<style scoped>
.no-telp {
    border: 1px solid #ededed;
    width: fit-content;
    padding: 2px 4px;
    border-radius: 4px;
    margin-right: 4px;
}
</style>
